export const currencies = {
  USD: 'usd',
  EUR: 'eur',
  PLN: 'pln',
  GBP: 'gbp',
  CHF: 'chf',
};
export const HARD_404_CURRENCY_CODES = [
  'azm',
  'bef',
  'bgl',
  'byb',
  'byr',
  'cyp',
  'dem',
  'ecs',
  'esp',
  'fim',
  'frf',
  'grd',
  'hrk',
  'iep',
  'itl',
  'ltl',
  'luf',
  'lvl',
  'mtl',
  'nlg',
  'pte',
  'rol',
  'rur',
  'sit',
  'skk',
  'tjr',
  'tmm',
  'trl',
  'xeu',
  'zwd',
];

export const EXCLUDED_CURRENCY_CODES = [
  ...HARD_404_CURRENCY_CODES,
  'byn',
  'rub',
];
export const currenciesInterbank = {
  USD: 'usd',
  EUR: 'eur',
};

export const CURRENCIES_OPTIONS = {
  all: 'all',
  money: 'money',
  crypto: 'crypto',
};

export const comments = {
  ACTIVE: 'active',
  CLOSED: 'closed',
};

export const convertorTypes = {
  CRYPTO: 'crypto',
};

export const periods = {
  WEEK: 'week',
  MONTH: 'month',
  QUARTER: 'quarter',
  YEAR: 'year',
  MAX: 'max',
};

export const periodsInNum = {
  week: 7,
  month: 30,
  quarter: 90,
  year: 365,
};

export const conversionNumbersListSourceToTarget = [
  1,
  10,
  25,
  50,
  100,
  500,
  1000,
  5000,
  10000,
];

export const conversionNumbersListTargetToSource = [
  100,
  500,
  1000,
  5000,
  10000,
  50000,
  100000,
  200000,
  500000,
];
